<div class="assign-ticket-dialog">
    <div class="dialog-header">
        <h2>Assign Ticket #{{data.ticketId}}</h2>
        <button class="close-btn" (click)="onCancel()">
            <img src="../../../../assets/images/close-icon.svg" alt="Close" />
        </button>
    </div>
    <div class="dialog-body">
        <!-- Selected users chips -->
        <div class="selected-chips" *ngIf="selectedUsers.length > 0">
            <span class="chip" *ngFor="let user of selectedUsers">
                {{ getUserDisplayName(user) }}
                <span class="chip-remove" (click)="removeUser(user)">&times;</span>
            </span>
        </div>

        <!-- Search input -->
        <div class="form-group">
            <label>Search Assignee</label>
            <input type="text" [formControl]="searchControl" placeholder="Search by name or email..."
                autocomplete="off" />
        </div>

        <!-- User list with multi-select -->
        <div class="user-list" *ngIf="!isLoading">
            <div class="user-item" *ngFor="let user of filteredUsers" (click)="toggleUser(user)"
                [class.selected]="isSelected(user)">
                <div class="user-checkbox">
                    <input type="checkbox" [checked]="isSelected(user)" (click)="$event.stopPropagation()" />
                </div>
                <div class="user-details">
                    <span class="user-name">{{ getUserDisplayName(user) }}</span>
                    <span class="user-email" *ngIf="user.email">{{ user.email }}</span>
                    <span class="user-role" *ngIf="user.role">{{ user.role }}</span>
                </div>
            </div>
            <div class="no-users" *ngIf="filteredUsers.length === 0">
                No users found.
            </div>
        </div>
        <div class="loading-text" *ngIf="isLoading">Loading users...</div>
    </div>
    <div class="dialog-footer">
        <span class="selected-count" *ngIf="selectedUsers.length > 0">{{ selectedUsers.length }} selected</span>
        <button class="btn-cancel" (click)="onCancel()">Cancel</button>
        <button class="btn-assign" (click)="onAssign()"
            [disabled]="selectedUsers.length === 0 || isSubmitting">Assign</button>
    </div>
</div>